module.exports = __webpack_public_path__ + "static/img/a201.cc7c812b.png";